<template>
    <div class="container container--narrow mgt-200">
      <div class=" t-center">
          <img src="/images/no-degree-data-image.svg" alt="" class="no-degree-image mgx-auto">
      </div>
      <div class="mgt-24 t-center t-headline8 font-r">
          {{ $t("3067") }}
      </div>
      <div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{ $t("3068") }}</div>
  </div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
//import HelpDeskList from '@/components/helpDesk/List'
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      tabBar: null,
    };
  },
  components: {
    TopAppBar,
    //HelpDeskList,
    // Faq: () => import("@/components/helpDesk/Faq.vue"),
    // Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  // mounted() {
  //   //this.setTopAppBarHomeBlank(this.$t('66'))
  //   $(document).ready(function () {
  //     $(".tabs").tabs();
  //   });
  //   this.tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
  //   this.setTabActive();
  //   this.setTopAppBarBackSearch(this.$t("1496"));
  // },

  // methods: {
  //   setTabActive() {
  //     let status = this.$route.query.status;
  //     if (status === "FAQ") {
  //       this.tabBar.activateTab(0);
  //     } else if (status == "INQUERY") {
  //       this.tabBar.activateTab(1);
  //     } else {
  //       this.tabBar.activateTab(0);
  //     }
  //   },
  // },
};
</script>

<style scoped>

.no-data-image {
  width: 123px;
  height: 143px;
}

#tab1,
#tab2 {
  margin-top: 56px;
}
</style>